export const LEAD_STATUS_OPTIONS = [
  { value: "", label: "All Candidates" },
  { value: "CONTACTED", label: "Contacted" },
  { value: "WAITING_ON_REPLY", label: "Waiting On Reply" },
  { value: "BOOKED_MEETING", label: "Booked Meeting" },
  { value: "DECLINED", label: "Declined" },
  { value: "HIRED", label: "Hired" },
] as const;

export const leadStatusLabel = (status?: string): string => {
  const normalized = (status || "").toUpperCase();
  switch (normalized) {
    case "CONTACTED":
      return "Contacted";
    case "WAITING_ON_REPLY":
      return "Waiting on reply";
    case "DECLINED":
      return "Declined";
    case "BOOKED_MEETING":
      return "Booked meeting";
    case "HIRED":
      return "Hired";
    default:
      return normalized || "Unknown";
  }
};

export const getLeadInitials = (firstName?: string, lastName?: string): string => {
  const f = (firstName || "").trim();
  const l = (lastName || "").trim();
  return ((f ? f[0] : "") + (l ? l[0] : "") || "?").toUpperCase();
};

export const formatLeadPhone = (countryCode?: string, phone?: string): string => {
  const code = (countryCode || "").startsWith("+")
    ? countryCode
    : `+${countryCode || ""}`;
  return `${code} ${phone || "N/A"}`.trim();
};
